//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HorizontalScrollbar from "./HorizontalScrollbar.vue";
import VerticalScrollbar from "./VerticalScrollbar.vue";

export default {
  name: "ScrollBar",
  components: {
    VerticalScrollbar,
    HorizontalScrollbar,
  },
  props: {
    bottomSpace: {
      type: Object,
      default: () => ({
        in: 0,
        out: 0,
      }),
    },
    margins: {
      type: Boolean,
      default: false,
    },
    scrollW: {
      type: Boolean,
      default: false,
    },
    speed: {
      type: Number,
      default: 53,
    },
    version: {
      type: String,
      default: null,
    },
    onMaxScroll: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      ready: false,
      top: 0,
      left: 0,
      scrollAreaHeight: null,
      scrollAreaWidth: null,
      scrollWrapperHeight: null,
      scrollWrapperWidth: null,
      vMovement: 0,
      hMovement: 0,
      dragging: false,
      start: { y: 0, x: 0 },
      allowBodyScroll: false,
      observer: null,
    };
  },
  computed: {
    canScrollX() {
      return this.scrollAreaWidth && this.scrollWrapperWidth
        ? this.scrollAreaWidth > this.scrollWrapperWidth
        : null;
    },
    canScrollY() {
      return this.scrollAreaHeight && this.scrollWrapperHeight
        ? this.scrollAreaHeight > this.scrollWrapperHeight
        : null;
    },
  },
  watch: {
    dragging(val) {
      this.$emit("onDrag", val);
    },
    left(val) {
      this.$emit("onScroll", { top: this.top, left: val });
    },
    top(val) {
      this.$emit("onScroll", { top: val, left: this.left });
    },
    async canScrollX(val) {
      this.$emit("onCanScroll", { x: val, y: this.canScrollY });
      setTimeout(() => {
        this.calculateSize();
      }, 10);
    },
    canScrollY(val) {
      this.$emit("onCanScroll", { x: this.canScrollX, y: val });
      setTimeout(() => {
        this.calculateSize();
      }, 10);
    },
    async version() {
      await this.calculateSize();
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(async () => {
        await this.calculateSize();
      }, 250);
    });
  },
  updated() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.calculateSize();
      }, 250);
    });
  },
  methods: {
    scroll(e) {
      this.calculateSize(() => {
        const num = this.speed;
        const shifted = e.shiftKey;
        const scrollY = e.deltaY > 0 ? num : -num;
        let scrollX = e.deltaX > 0 ? num : -num;

        if (shifted && e.deltaX == 0) scrollX = e.deltaY > 0 ? num : -num;

        const nextY = this.top + scrollY;
        const nextX = this.left + scrollX;

        if (this.canScrollY && !shifted) this.normalizeVertical(nextY);
        if (shifted && this.canScrollX) this.normalizeHorizontal(nextX);
      });
      if (!this.allowBodyScroll) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    startDrag(e) {
      this.touchEvent = e;
      const evt = e.changedTouches ? e.changedTouches[0] : e;

      this.calculateSize(() => {
        this.dragging = true;
        this.start = { y: evt.pageY, x: evt.pageX };
      });
    },
    onDrag(e) {
      if (this.dragging) {
        e.preventDefault();
        e.stopPropagation();

        if (this.touchEvent) {
          this.touchEvent.preventDefault();
          this.touchEvent.stopPropagation();
        }
        const evt = e.changedTouches ? e.changedTouches[0] : e;
        const yMovement = this.start.y - evt.clientY;
        const xMovement = this.start.x - evt.clientX;
        this.start = { y: evt.clientY, x: evt.clientX };

        const nextY = this.top + yMovement;
        const nextX = this.left + xMovement;
        this.normalizeVertical(nextY);
        this.normalizeHorizontal(nextX);
      }
    },
    stopDrag() {
      this.dragging = false;
      this.touchEvent = false;
    },
    scrollToY(y) {
      this.normalizeVertical(y);
    },
    scrollToX(x) {
      this.normalizeHorizontal(x);
    },
    normalizeVertical(next) {
      const elementSize = this.getSize();
      const lowerEnd = elementSize.scrollAreaHeight - elementSize.scrollWrapperHeight;
      const maxBottom = next > lowerEnd;

      if (maxBottom) next = lowerEnd;

      const maxTop = next < 0;

      if (maxTop) next = 0;

      const shouldScroll = this.top !== next;
      this.allowBodyScroll = !shouldScroll;

      if (shouldScroll) {
        this.top = next;
        this.vMovement = (next / elementSize.scrollAreaHeight) * 100;
        if (this.onMaxScroll && (maxTop || maxBottom)) {
          this.onMaxScroll({
            top: maxTop,
            bottom: maxBottom,
            right: false,
            left: false,
          });
        }
      }
    },
    normalizeHorizontal(next) {
      const elementSize = this.getSize();
      const rightEnd = elementSize.scrollAreaWidth - this.scrollWrapperWidth;
      this.$emit("onRightEnd", rightEnd);
      const maxRight = next > rightEnd;
      if (maxRight) next = rightEnd;

      const maxLeft = next < 0;

      if (next < 0) next = 0;

      const shouldScroll = this.left !== next;
      this.allowBodyScroll = !shouldScroll;

      if (shouldScroll) {
        this.left = next;
        this.hMovement = (next / elementSize.scrollAreaWidth) * 100;
        if (this.onMaxScroll && (maxRight || maxLeft)) {
          this.onMaxScroll({
            right: maxRight,
            left: maxLeft,
            top: false,
            bottom: false,
          });
        }
      }
    },
    handleChangePosition(movement, orientation) {
      this.calculateSize(() => {
        const next = movement / 100;
        if (orientation == "vertical") this.normalizeVertical(next * this.scrollAreaHeight);
        if (orientation == "horizontal") this.normalizeHorizontal(next * this.scrollAreaWidth);
      });
    },
    handleScrollbarDragging() {
      this.dragging = true;
    },
    handleScrollbarStopDrag() {
      this.dragging = false;
    },
    getSize() {
      let scrollWrapperHeight;
      let scrollWrapperWidth;
      const $scrollArea = this.$refs.scrollArea;
      const $scrollWrapper = this.$refs.scrollWrapper;
      const canScrollXOffset = this.canScrollX ? 20 : 0;

      if ($scrollWrapper) {
        if (this.canScrollY) {
          scrollWrapperHeight = $scrollWrapper.parentNode.clientHeight;
        } else {
          scrollWrapperHeight =
            $scrollWrapper.parentNode.clientHeight -
            (this.bottomSpace.in + this.bottomSpace.out + canScrollXOffset);
        }
        if (this.canScrollX) {
          scrollWrapperWidth = $scrollWrapper.clientWidth;
        } else {
          scrollWrapperWidth = $scrollWrapper.children[0].clientWidth;
        }
      } else {
        scrollWrapperWidth = 0;
        scrollWrapperHeight = 0;
      }

      return {
        scrollAreaHeight: $scrollArea ? $scrollArea.children[0].clientHeight : 0,
        scrollAreaWidth: $scrollArea ? $scrollArea.children[0].clientWidth : 0,
        scrollWrapperHeight,
        scrollWrapperWidth,
      };
    },
    calculateSize(cb) {
      if (typeof cb !== "function") cb = null;
      const elementSize = this.getSize();
      if (
        elementSize.scrollWrapperHeight !== this.scrollWrapperHeight ||
        elementSize.scrollWrapperWidth !== this.scrollWrapperWidth ||
        elementSize.scrollAreaHeight !== this.scrollAreaHeight ||
        elementSize.scrollAreaWidth !== this.scrollAreaWidth
      ) {
        this.scrollAreaHeight = elementSize.scrollAreaHeight;
        this.scrollAreaWidth = elementSize.scrollAreaWidth;
        this.scrollWrapperHeight = elementSize.scrollWrapperHeight;
        this.scrollWrapperWidth = elementSize.scrollWrapperWidth;
        this.ready = true;

        this.scrollToY(this.top);
        this.scrollToX(0);

        return cb ? cb() : false;
      } else return cb ? cb() : false;
    },
  },
};
